import { render, staticRenderFns } from "./exportOrderNumber.vue?vue&type=template&id=b0ac4ac6&scoped=true"
import script from "./exportOrderNumber.vue?vue&type=script&lang=js"
export * from "./exportOrderNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ac4ac6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0ac4ac6')) {
      api.createRecord('b0ac4ac6', component.options)
    } else {
      api.reload('b0ac4ac6', component.options)
    }
    module.hot.accept("./exportOrderNumber.vue?vue&type=template&id=b0ac4ac6&scoped=true", function () {
      api.rerender('b0ac4ac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fixDutyFine/LMLiabilityForLosses/cmp/exportOrderNumber.vue"
export default component.exports